import './pagination.scss';
/**
 * Nest this component inside your other component to
 * provide a pagination
 *
 * <pagination for="<THE_SCOPE_FROM_THE_COMPONENT>"></pagination>
 *
 * See src/public-booking/templates/_events.component.html for more
 * @type {{templateUrl: string, bindings: {for: string}}}
 */
const paginationComponent = {
    templateUrl: require('./pagination.component.html').id,
    bindings: {
        for: '<',
        perPage: '<',
        disabledIf: '<'
    },
    // controller() {
    //     this.templateOverride = require('./pagination.component.template.html').id;
    // }
};
angular.module('BBPublicBooking').component('bbPagination', paginationComponent);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/public-booking/pagination/pagination.component.js